export enum PROPOSAL_OPERATION_TYPE {
  NEW_LOAN = 'NEW_LOAN',
  DEBT_TRANSFER = 'DEBT_TRANSFER',
  RENEGOTIATION = 'RENEGOTIATION',
  REFINANCE = 'REFINANCE',
}
